import {Component} from '@angular/core';
import {IonicModule} from "@ionic/angular";

@Component({
  selector: 'sol-crm-loading',
  standalone: true,
  imports: [
    IonicModule
  ],
  template: `
    <div class="hero" style="height: 200px; padding: 25px 0">
      <ion-skeleton-text [animated]="true" />
    </div>
    <ion-row>
      <ion-col>
        <ion-label>
          <ion-skeleton-text [animated]="true"/>
        </ion-label>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12" size-lg="6" push-lg="3">
        <ion-row>
          <ion-col size="=3" class="center">
            <ion-item>
              <ion-label>
                <ion-skeleton-text [animated]="true"/>
              </ion-label>
            </ion-item>
          </ion-col>
          <ion-col size="9">
            <ion-item>
              <ion-label>
                <ion-skeleton-text [animated]="true" style="width: 80%" />
              </ion-label>
            </ion-item>
            <ion-item>
              <ion-label>
                <ion-skeleton-text [animated]="true" style="width: 80%" />
              </ion-label>
            </ion-item>
          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row>
  `,
  styles: `
    .hero {
      display: flex;
      align-items: center;
      justify-content: center;
      background: #FFF;
      padding: 25px 40px;
      border-radius: 0 0 25px 25px;
      box-shadow :#e0e0e0 0 0 11px;
      margin-bottom: 15px;

      img {
        max-width: 250px;
        width: 60%;
      }
    }
  `
})
export class CRMLoadingComponent {

}
